import { Eyebrow, Reveal } from "../landing/shared";

const VALUES = [
    {
        title: "Global Sourcing",
        copy: "Access talent across relevant international markets.",
    },
    {
        title: "Qualified Candidates",
        copy: "Candidate sourcing aligned with defined employer requirements.",
    },
    {
        title: "Mobility Support",
        copy: "Support through applicable documentation and cross-border mobility processes.",
    },
];

export const ValueProps = () => (
    <section data-testid="employer-value-section" className="bg-ivory py-24 lg:py-32">
        <div className="mx-auto max-w-7xl px-6 lg:px-10">
            <div className="grid gap-14 lg:grid-cols-12 lg:gap-20">
                <Reveal className="lg:col-span-5">
                    <div className="lg:sticky lg:top-32">
                        <Eyebrow>Employer Recruitment</Eyebrow>
                        <h2 className="mt-5 font-serif text-3xl font-medium tracking-tight text-ink sm:text-4xl lg:text-5xl">
                            Global Talent. Structured Recruitment.
                        </h2>
                        <p className="mt-6 max-w-md text-base leading-relaxed text-ink/65">
                            Finding the right people across borders can be complex. Afrinexa Global helps
                            organizations identify, source and connect with talent for international
                            workforce requirements.
                        </p>
                    </div>
                </Reveal>

                <div className="lg:col-span-7">
                    {VALUES.map((value, i) => (
                        <Reveal key={value.title} delay={i * 0.08}>
                            <div
                                data-testid={`value-${value.title.toLowerCase().replace(/[^a-z]+/g, "-")}`}
                                className="grid grid-cols-[auto_1fr] gap-6 border-t border-ink/10 py-8 lg:gap-10"
                            >
                                <span className="font-serif text-3xl font-medium text-forest/35">
                                    {String(i + 1).padStart(2, "0")}
                                </span>
                                <div>
                                    <h3 className="text-base font-semibold uppercase tracking-[0.14em] text-ink">
                                        {value.title}
                                    </h3>
                                    <p className="mt-3 max-w-lg text-sm leading-relaxed text-ink/60">
                                        {value.copy}
                                    </p>
                                </div>
                            </div>
                        </Reveal>
                    ))}
                    <div className="border-t border-ink/10" />
                </div>
            </div>
        </div>
    </section>
);
